import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

export function useUpdateMeeting(onDone) {
  const mutationFactory = useCallback(() => {
    const query = `
        mutation updateEvent($updateEventInput: UpdateEventInput!) {
            updateEvent(updateEventInput: $updateEventInput) {
            event {
                id
                name
            }
            }
        }`;

    const resolver = (resp) => {
      return resp;
    };

    return { query, resolver };
  }, []);

  const [updateMeetingMutation, { loading }] = useMutationWithToaster(
    mutationFactory,
    { onDone }
  );

  return {
    isUpdating: loading,
    updateMeeting: async (formData, meetingId) => {
      return updateMeetingMutation(
        {
          updateEventInput: {
            id: meetingId,
            name: formData.name,
            meetingTypeId: formData.type.id,
            startDate: formData.startDate,
            endDate: formData.endDate,
            attendees: formData.attendees.map(({ id }) => {
              return id;
            }),
          },
        },
        {
          successMsg: `Successfully updated meeting ${formData.name}`,
          defaultErrorMsg:
            "Failed to update event. Please retry or contact support for assistance.",
        }
      );
    },
  };
}

export default useUpdateMeeting;
